'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isFocus", "className"];
import React, { useContext } from 'react';
import cx from 'classnames';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Arrow } from "./Arrow.mjs";
import { Button } from "./Button.mjs";
import { textClass } from "../../styles/layout-theme.mjs";
/**
 * Use the PaginationDropdown component when you need a user to navigate between pages of data, by selecting a pagination number from a list.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-pagination-paginationdropdown--docs) |
 * [Encore site](https://encore.spotify.net/web/components/pagination#pagination-dropdown) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PaginationDropdown) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12486&t=10cChvdYyvmld0PS-1)
 */
export var PaginationDropdown = /*#__PURE__*/React.forwardRef(function PaginationDropdown(_ref, ref) {
  var children = _ref.children,
    isFocus = _ref.isFocus,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    ref: ref,
    $isUsingKeyboard: isUsingKeyboard,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    $isFocus: isFocus,
    "aria-haspopup": "listbox",
    className: cx(textClass('bodySmallBold'), className)
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.PaginationDropdown
  }), children, /*#__PURE__*/React.createElement(Arrow, null));
});